import React, { Component } from "react";
import '../../css/App.css';
import { IconButton } from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import PlusIcon from '@rsuite/icons/Plus';
import "rsuite/dist/rsuite.min.css";

class BtnCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.roles = props.roles;
    this.btnClickedHandler = this.btnClickedHandler.bind(this);
  }
  btnClickedHandler() {
    this.props.clicked(this.props.data);
  }
  render() {
    if (this.props.data.isBottomTable || this.props.data.clientName === "BONUS" || this.props.data.clientName === "ANTYBONUS" || this.props.data.clientName === "BONUS ŚWIĄTECZNY" || this.props.data.clientName === "BLOKADA" || this.props.data.clientName === "ZWROT BLOKADY" || this.props.data.clientName === "DODATKOWA OPŁATA") {
      return null;
    }
    if (this.props.data.isFinished || this.roles?.includes('ACCOUNT_MANAGER') || this.roles?.includes('SUPERVISOR')) {
      return <IconButton icon={<SearchIcon />} style={{margin:"0px -8px", width: 23, height: 23}} onClick={this.btnClickedHandler} color={this.props.column.colId === "overdue" ? 'default' : "green"} appearance="primary" size="sm"/>
    }
    else {
      return <IconButton icon={<PlusIcon />} onClick={this.btnClickedHandler} style={{margin:"0px -8px", width: 23, height: 23}} color={this.props.column.colId === "overdue" ? 'default' : "green"} appearance="primary" size="sm"/>
    }
  }
}

export default BtnCellRenderer;

